import {
  createEquipmentDetailsCall,
  updateEquipmentDetails,
} from './digidiary.service';
import {getUserIDState, handleAlert, getEquipmentState} from './sagaHelper';
import {getCustomerId} from './selectors';

import {
  PUSH_DIGIDIARY_VIEW,
  DIGIDIARY_SET_LOADER,
  DIGIDIARY_ADD_EQUIPMENT,
  DD_UPDATE_IMPLEMENTS_DETAILS,
} from '../actions';

import {call, put, select, takeEvery} from 'redux-saga/effects';

export function* updateImplements({data}) {
  const customerId = yield select(getCustomerId);
  const response = yield updateEquipmentDetails(customerId, data);
  if (response.statusCode && response.statusCode === 200) {
    let newView = 'myFarm';
    yield put({type: PUSH_DIGIDIARY_VIEW, newView});
    yield call(handleAlert, {variant: 'success', type: 'updateEquipment'});
  } else {
    yield call(handleAlert, {variant: 'error', type: 'alertError'});
  }
}

export function* addEquipmentData({data}) {
  let flag = true;
  yield put({type: DIGIDIARY_SET_LOADER, flag});

  const equipmentState = yield select(getEquipmentState);
  let userId = yield select(getUserIDState);

  let payload = {...equipmentState};
  const response = yield createEquipmentDetailsCall(userId, payload);

  flag = false;
  yield put({type: DIGIDIARY_SET_LOADER, flag});
  if (response.statusCode && response.statusCode === 200) {
    let newView = 'firstTimeEquipmentSetup';
    if (data && data === 'addNew') {
      yield put({type: PUSH_DIGIDIARY_VIEW, newView});
    }

    yield call(handleAlert, {variant: 'success', type: 'addEquipmentSuccess'});
  } else {
    yield call(handleAlert, {variant: 'error', type: 'alertError'});
  }
}

export function* addEquipmentSaga() {
  yield takeEvery(DIGIDIARY_ADD_EQUIPMENT, addEquipmentData);
  yield takeEvery(DD_UPDATE_IMPLEMENTS_DETAILS, updateImplements);
}
